import { ScopeReportLineItem } from '../ScopeReportTypes';

/**
 * @param lineItems - The line items to filter.
 * @returns The filtered line items.
 */
export const filterPunchlistLineItems = (lineItems: ScopeReportLineItem[]): ScopeReportLineItem[] => {
  return lineItems.filter(item => item.isPunchlistTask === true);
};
